export const handleScrollToId = (
	e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
	id: string,
) => {
	e.preventDefault();
	document.getElementById(id)?.scrollIntoView({
		behavior: "smooth",
		block: "start",
	});
};

export const handleScrollToTop = () => {
	window.scrollTo({ top: 0, behavior: "smooth" });
};
